import React from 'react'
import TwoStepPaymentFormHeaderItemUi from './ui/two-step-payment-form-header-item-ui'
import TwoStepPaymentFormStepHeaderHeadlinesUi from './ui/two-step-payment-form-step-header-headlines'
import TwoStepPaymentFormStepHeaderNumberUi from './ui/two-step-payment-form-step-header-number-ui'
import TwoStepPaymentFormStepHeadlineUi from './ui/two-step-payment-form-step-headline-ui'
import TwoStepPaymentFormStepSubHeadlineUi from './ui/two-step-payment-form-step-sub-headline-ui'

export interface TwoStepPaymentFormHeaderItemProps {
  active?: boolean
  headline: string
  number: number
  subHeadline: string
  headerUnderlineColor: string
  backgroundColor?: string
  mobileBackgroundColor?: string
  color: string
  mobileColor?: string
}

export const TwoStepPaymentFormHeaderItem = ({
  active = false,
  headline,
  subHeadline,
  color,
  mobileColor,
  backgroundColor,
  mobileBackgroundColor,
  number,
  headerUnderlineColor,
}: TwoStepPaymentFormHeaderItemProps) => {
  return (
    <TwoStepPaymentFormHeaderItemUi
      active={active}
      color={color}
      mobileColor={mobileColor}
      backgroundColor={backgroundColor}
      mobileBackgroundColor={mobileBackgroundColor}
      headerUnderlineColor={headerUnderlineColor}
    >
      <TwoStepPaymentFormStepHeaderNumberUi>
        {number}
      </TwoStepPaymentFormStepHeaderNumberUi>
      <TwoStepPaymentFormStepHeaderHeadlinesUi>
        <TwoStepPaymentFormStepHeadlineUi>
          {headline}
        </TwoStepPaymentFormStepHeadlineUi>
        <TwoStepPaymentFormStepSubHeadlineUi>
          {subHeadline}
        </TwoStepPaymentFormStepSubHeadlineUi>
      </TwoStepPaymentFormStepHeaderHeadlinesUi>
    </TwoStepPaymentFormHeaderItemUi>
  )
}
